module.exports = __webpack_public_path__ + "static/media/world.d738a25e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/world.jpg
// module id = 426
// module chunks = 0